import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EventService } from 'src/app/services/event.service';

@Component({
  selector: 's18-process-status-dialog',
  templateUrl: './process-status-dialog.component.html',
  styleUrls: ['./process-status-dialog.component.scss']
})
export class ProcessStatusDialogComponent implements OnInit, OnDestroy {
  guid: string;
  statusText = '';
  intervalId: any;
  polling = true;
  apiCompleted = false;

  constructor(
    private dialogRef: MatDialogRef<ProcessStatusDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private eventService: EventService
  ) {
    this.guid = data.guid;
    if (data.message) {
      this.statusText = data.message;
    }
    
    // If apiCompletionCallback is provided, we'll wait for it
    if (data.apiCompletionCallback) {
      data.apiCompletionCallback.subscribe(() => {
        this.apiCompleted = true;
        // Check if we can close now
        this.checkCanClose();
      });
    } else {
      // No callback means we don't need to wait for API
      this.apiCompleted = true;
    }
  }

  ngOnInit() {
    this.poll();
    this.intervalId = setInterval(() => this.poll(), 3000);
  }

  poll() {
    if (!this.guid) {
      return;
    }
    this.eventService.getProcessStatus(this.guid).subscribe(resp => {
      try {
        const parsed = JSON.parse(resp.d);
        const status = parsed.status || '';
        const running = parsed.running;
        this.statusText = status;
        
        // Stop polling if running is 0 AND API has completed
        if (running === 0 || running === '0') {
          this.checkCanClose();
          return;
        }
        
        // Also check for completion keywords as fallback
        const normalized = (status || '').toLowerCase();
        if (normalized.indexOf('complete') > -1 || normalized.indexOf('finished') > -1 || normalized.indexOf('success') > -1) {
          this.checkCanClose();
        }
      } catch (e) {
        // ignore parse errors
      }
    }, err => {
      // ignore polling errors
    });
  }

  checkCanClose() {
    // Only close if API has completed
    if (this.apiCompleted) {
      this.close(true);
    }
  }

  close(result: boolean) {
    this.polling = false;
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
    this.dialogRef.close(result);
  }

  ngOnDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
}
